import AuthFooter from '../../components/auth/AuthFooter'
import * as SubscriptionActions from '../../redux/actions/SubscriptionActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import { useState, useEffect, useMemo } from 'react'
import Header from './Header'
import ChooseLicense from './ChooseLicense'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useDispatch, useSelector } from 'react-redux'
import { subscriptionManager } from '../../utils/Helper'
import PricingTabs from '../pricing/PricingTabs'
import PricingLegal from '../pricing/PricingLegal'
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK)

const Subscribe = () => {
  const dispatch = useDispatch()
  const {
    subscriptions: {
      user: mySubscription,
      products,
      loading: userSubscriptionLoading,
    },
  } = useSelector((state) => state)
  const [pricingDurationActive, setPricingDurationActive] = useState(1)
  const [activeTab, setActiveTab] = useState(1)
  const {
    auth: { user: authUser },
  } = useSelector((state) => state)

  const loadUserSubscriptions = () => {
    dispatch(SubscriptionActions.currentUserSubscription())
  }

  const loadSubscriptionProducts = () => {
    dispatch(SubscriptionActions.getAllSubscriptionProducts())
  }

  const subscriptionData = useMemo(() => {
    return (
      mySubscription &&
      products.length &&
      subscriptionManager({
        authUser,
        userSubscription: mySubscription,
        products,
      })
    )
  }, [mySubscription, products, authUser])

  useEffect(() => {
    loadSubscriptionProducts()
    loadUserSubscriptions()
  }, [])

  return (
    <Elements stripe={stripePromise}>
      <div className={'tikbox-subscribe'}>
        <div className="masthead py-12 navHeader">
          <Header />
          {userSubscriptionLoading && (
            <div style={{ textAlign: 'center' }}>
              <p>
                <span style={{ fontSize: 12 }}>Loading subscription </span>{' '}
                <FontAwesomeIcon className="spinner" icon={faSpinner} />
              </p>
            </div>
          )}
          {!userSubscriptionLoading && subscriptionData?.activeSubscription && (
            <div style={{ textAlign: 'center' }}>
              <h1>
                You are subscribed to{' '}
                <strong>
                  {subscriptionData?.subscriptionProduct?.name}
                  {subscriptionData?.isTrialPlan && ' (Trial)'}
                </strong>
              </h1>
            </div>
          )}
          <div className="pricing">
            <div className="pricing-container">
              {subscriptionData?.isUgradeablePlan && (
                <PricingTabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  pricingDurationActive={pricingDurationActive}
                  setPricingDurationActive={setPricingDurationActive}
                  disableDeveloperAPI
                />
              )}
              {activeTab === 1 && (
                <div className="pricing-plans">
                  {subscriptionData?.isUgradeablePlan && (
                    <ChooseLicense
                      products={products}
                      pricingDurationActive={pricingDurationActive}
                      show
                      subscriptionData={subscriptionData}
                      pageOn="subscribe"
                    />
                  )}
                </div>
              )}
              {activeTab === 3 && <PricingLegal />}
            </div>
          </div>
        </div>
        <div className="" style={{ margin: '0 auto' }}>
          <AuthFooter />
        </div>
      </div>
    </Elements>
  )
}

export default Subscribe
